import React, { memo } from 'react';
import styles from './dialogRightTagSubtitle.module.scss';

const DialogRightTagSubtitle = ({ children }) =>
    <div className={styles.dialogRightTagSubtitle}>
        {children}
    </div>

export default memo(DialogRightTagSubtitle);